import { render, staticRenderFns } from "./DelimiterTextArea.vue?vue&type=template&id=0b834fd2"
import script from "./DelimiterTextArea.vue?vue&type=script&lang=ts"
export * from "./DelimiterTextArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports